import React, { useState, useEffect } from "react";
import Lightbox from "react-awesome-lightbox";

import {

  Sector,
  PieChart,
  Pie,

} from "recharts";
import "react-awesome-lightbox/build/style.css";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";

import MultiSelect from "react-multi-select-component";
import Select from "react-select";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../../../styles/app/pages/CampaingPreview.scss";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { Modal } from "react-bootstrap";
import "../../styles.css"
export const Report1 = ({ props, queryng }) => {


  const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, percent } = props;
    return (
      <g>
        <text x={cx} y={cy} dy={6} textAnchor="middle" fill="#5E78FF">
          {Number((percent * 100).toFixed(2))}%
        </text>

        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill="#5E78FF"
        />
      </g>
    );
  };
  const [index, setIndex] = useState(0)

  const onPieEnter = (_, index) => {
    setIndex(index)
  };

  const _rows = props.rows.sort((a, b) => a.no - b.no);
  const [mainKey, setMainKey] = useState("yesno");
  const [mainTask, setMainTask] = useState("");
  const pos_map = _rows.map((key) => key.pos);
  const pos_unique = [...new Set(pos_map)];
  const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
  const [pos_selected, pos_setSelected] = useState([]);

  const round_map = _rows.map((key) => key.round);
  const round_unique = [...new Set(round_map)];
  const round_options = round_unique.map((key) => ({ label: key, value: key }));
  const [round_selected, round_setSelected] = useState([]);

  const product_map = _rows.map((key) => key.product);
  const product_unique = [...new Set(product_map)];
  const product_options = product_unique.map((key) => ({
    label: key,
    value: key,
  }));
  const [product_selected, product_setSelected] = useState([]);


  const [agent_selected, agent_setSelected] = useState([]);

  const task_map = _rows.map((key) => key.task);
  const task_unique = [...new Set(task_map)];
  const task_options = task_unique.map((key) => ({ label: key, value: key }));
  const [task_types, tasktypes_setSelected] = useState([]);

  useEffect(() => {
    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
    pos_setSelected(pos_options);
    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({
      label: key,
      value: key,
    }));
    round_setSelected(round_options);
    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique.map((key) => ({
      label: key,
      value: key,
    }));
    product_setSelected(product_options);
    const agent_map = _rows.map((key) => key.agent);
    const agent_unique = [...new Set(agent_map)];
    const agent_options = agent_unique.map((key) => ({
      label: key,
      value: key,
    }));
    agent_setSelected(agent_options);
    const task_map = props.tasks.map((key) => key.name);
    const tasks_types = [
      ...new Set(props.tasks.map((key) => key.input_type).flat()),
    ].reduce((hs, tp) => ({ ...hs, [tp]: true }), {});
    tasktypes_setSelected(tasks_types);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key, value: key }));
    const [default_task] = task_options;
    default_task && setMainTask(default_task);

  }, [_rows, props.tasks]);

  const raw = _rows
    .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    .filter((row) => product_selected.map((row) => row.value).includes(row.product))
    .filter((row) => agent_selected.map((row) => row.value).includes(row.agent));




  const data = {};
  for (const row of raw) {
    const key = data[row.pos] ?? {};
    const round = key[row.round] ?? {};
    const product = round[row.product] ?? {};
    const task = product[row.task] ?? {};
    if (task_types["File (photo)"]) {
      task.file = row.file;
      task.image = row.image;
    }
    if (task_types["Rate"]) {
      task.rate = row.rate;
    }
    if (task_types["Comment"]) {
      task.comment = row.comment;
    }
    if (task_types["Yes/No"]) {
      task.yesno = row.yesno;
    }
    if (task_types["Quantity"]) {
      task.quantity = row.quantity;
      task.sku = row.sku ?? 0;
    }
    task.manufacture = row.manufacture;

    product[row.task] = task;
    round[row.product] = product;
    key[row.round] = round;
    data[row.pos] = key;
  }

  const convert = {
    Rate: "rate",
    "Yes/No": "yesno",
    Quantity: "quantity",
  };

  const [images, openImages] = useState([])
  const [content, setContent] = useState("")
  return (
    <>
      <Modal

        show={images.length > 0}
        closeButton
        onHide={() => openImages([])}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <h3><strong>Images</strong></h3>
        </Modal.Header>
        <Modal.Body>
          {content !== "" && (
            <Lightbox
              image={content}
              onClose={() => {
                setContent("");
              }}
            />
          )}
          <Row>

            {images.map((source) => {
              return (
                <Col xs={3} className="pointer-hover text-center p-2">
                  <div className="card pt-3" onClick={() => setContent(source.image)}>
                    <img src={source.image} alt="" key={source.name} className="img-planogram p-1 m-auto" />
                    <br />
                    <span className="text-muted">{source.name}</span>
                  </div>

                </Col>
              )
            })}
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <butotn className="btn btn-secondary" onClick={() => openImages([])}>
            Close
          </butotn>
        </Modal.Footer>
      </Modal>
      <Card.Body className="p-4 mt-5">
        <Container fluid>
        <br />
          <div className="card p-2 shadow-sm pb-5 px-4">
            <h4 className="text-muted">Filters Criteria</h4>
            <Row className="w-100 justify-content-end"></Row>
            <br />
            <Row>
              <Col>
                <label>Select POS</label>
                <MultiSelect
                  name="pos"
                  options={pos_options}
                  value={pos_selected}
                  onChange={pos_setSelected}
                  labelledBy={"Select POS"}
                />
              </Col>
              <Col>
                <label>Select Rounds</label>
                <MultiSelect
                  name="round"
                  options={round_options}
                  value={round_selected}
                  onChange={round_setSelected}
                  labelledBy={"Select Round"}
                />
              </Col>
              <Col>
                <label>Select Products</label>
                <MultiSelect
                  name="product"
                  options={product_options}
                  value={product_selected}
                  onChange={product_setSelected}
                  labelledBy={"Select Product"}
                />
              </Col>
              <Col xs={3}>
                <label>Select Task</label>
                <Select
                  value={mainTask}
                  options={task_options}
                  onChange={setMainTask}
                />
              </Col>
              <Col>
                <label>Select Input Type</label>
                <select
                  className="form-control form-control-solid"
                  name="task"
                  value={mainKey}
                  onChange={(ev) => {
                    setMainKey(ev.target.value);
                  }}
                >
                  {Object.entries(convert).map(([name, field]) => (
                    <option
                      key={name}
                      value={field}
                      disabled={!task_types[name]}
                    >
                      {name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
          </div>
          <br />

          <br />
          {!queryng ? (
            props.rows.length === 0 ? <div>
              <>
                <div className="row">
                  <div className="col-md-12 d-flex w-100 justify-content-center text-center">
                    <div>
                      <SVG src={toAbsoluteUrl("/media/svg/undraw/undraw_No_data_re_kwbl.svg")} style={{ display: "block", width: "60%", margin: "auto" }} />
                      <p>
                        <strong>Don't</strong> have any <b>Result</b>
                      </p>
                    </div>
                  </div>

                </div>
              </>
            </div> :
              <>
                <br />

                <span className="text-muted h4 mb-3">Task: </span><span className="h2"><strong>{mainTask.label}</strong></span>
                <br />
                <br />

                {Object.entries(data).map(([pos, rounds]) => (
                  <>

                    <span className="text-muted h5">Location: </span><span className="h3"><strong>{pos}</strong></span>
                    <div className="charts__container my-2">
                      {Object.entries(rounds).map(([round, products]) => {
                        const summary = {};
                        for (const _tasks of Object.values(products)) {
                          const task = _tasks[mainTask.value] ?? {};
                          summary.quantity = summary.quantity
                            ? [task.quantity, ...summary.quantity]
                            : [task.quantity];
                          summary.rate = summary.rate
                            ? [...summary.rate, task.rate]
                            : [task.rate];
                          summary.yesno = summary.yesno
                            ? [...summary.yesno, task.yesno]
                            : [task.yesno];
                        }
                        const chart = summary[mainKey]
                          .filter(Boolean)
                          .reduce((hash, val) => ({
                            ...hash,
                            [val]: ++hash[val],
                          }), {
                            YES: 0,
                            NO: 0
                          });
                        const collapsed = Object.entries(chart).map(([name, value]) => ({
                          name,
                          value: Number(value),
                        }));
                        const _products_entries = Object.entries(products)
                        const _products_values = Object.values(products)
                        const average_total = _products_values.map((data) =>
                          ((data[mainTask.value]?.[mainKey] ?? 0) /
                            (data[mainTask.value]?.sku ?? 1)) *
                          100).reduce((ttl, avr) => ttl + avr, 0) / _products_values.length;
                        const _images = _products_entries.map(([key, pro]) => ({ name: key, image: pro[mainTask.value]?.image ?? "" })).filter(prd => prd.image)
                        return (
                          <Col xs={5}>

                            <Card className="mb-2 shadow-sm">
                              <Card.Header style={{ backgroundColor: "#5E78FF", color: "white" }}>
                                <div className="w-100 d-flex justify-content-between">


                                  <h3 className="strong"><strong>Visit #{round}</strong></h3>
                                  <button className="btn btn-secondary"
                                    disabled={!_images.length}
                                    onClick={() => openImages(_images)}
                                  >
                                    <strong>
                                      See Photos
                                    </strong>
                                  </button>
                                </div>
                              </Card.Header>
                              <Card.Body>

                                <div className="report__table">
                                  <div>
                                    <div className="row w-60">
                                      <div className="col">

                                        <strong>
                                          <p>Products</p>
                                        </strong>
                                      </div>
                                      <div className="col">
                                        <div className="row w-100 justify-content-center">
                                          <strong>
                                            <p>Results</p>
                                          </strong>
                                        </div>

                                      </div>
                                    </div>

                                    <div className="">
                                      {_products_entries.map(
                                        ([product, data], index) => (
                                          <div className="row w-60">
                                            <div className="col">
                                              <p key={index}>
                                                #{index + 1}: {product}
                                              </p>
                                            </div>
                                            <div className="col">
                                              <div className="row w-100 justify-content-center">

                                                <p key={index} style={{ height: "100%", verticalAlign: "middle" }}>
                                                  {data[mainTask.value]?.[mainKey] ?? (
                                                    <span className="badge badge-danger">
                                                      No results
                                                    </span>
                                                  )}
                                                </p>
                                              </div>

                                            </div>
                                          </div>

                                        )
                                      )}
                                    </div>
                                  </div>
                                  {mainKey === "quantity" && (
                                    <div className="report__table--target">
                                      <strong>
                                        <p>Targets</p>
                                      </strong>
                                      {_products_entries.map(
                                        ([product, data], index) => (
                                          <p key={index}>
                                            {data[mainTask.value]?.sku}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  )}

                                  {mainKey === "quantity" && (
                                    <div className="report__table--percentage">
                                      <strong>
                                        <p>%</p>
                                      </strong>
                                      {_products_entries.map(([product, data], index) => (
                                        <p key={index}>
                                          {(
                                            ((data[mainTask.value]?.[
                                              mainKey
                                            ] ?? 0) /
                                              (data[mainTask.value]
                                                ?.sku ?? 1)) *
                                            100
                                          ).toFixed(2)}
                                          %
                                        </p>
                                      )
                                      )}
                                    </div>
                                  )}

                                  {mainKey === "yesno" && (
                                    <div className="report__table--average__chart" style={{ width: "100%" }}>
                                      <strong>Average</strong>

                                      <PieChart
                                        width={100}
                                        height={100}
                                      >
                                        <Pie
                                          animation="border"
                                          activeIndex={index}
                                          activeShape={renderActiveShape}
                                          data={[...collapsed]}
                                          cx="50%"
                                          cy="50%"
                                          innerRadius={35}
                                          outerRadius={45}
                                          fill="#ff6161"
                                          stroke="#ff6161"
                                          dataKey="value"
                                          onMouseEnter={onPieEnter}
                                        />
                                      </PieChart>
                                      <div className="pl-5">
                                        <div className="row text-center w-100 ">

                                          <div className="col-6">
                                            YES
                                            <hr
                                              style={{
                                                margin: "auto",
                                                height: "5px",
                                                width: "30px",
                                                borderTop: `5px solid #5E78FF`,

                                              }}
                                            />
                                          </div>
                                          <div className="col-6 ">
                                            NO
                                            <hr
                                              style={{
                                                margin: "auto",
                                                height: "5px",
                                                width: "30px",
                                                borderTop: `5px solid #dc3545`,

                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  )}
                                  {mainKey === "quantity" && (
                                    <div className="report__table--average__date">
                                      <strong>Average</strong>
                                      <strong>
                                        <p>
                                          {Number(average_total).toFixed(
                                            2
                                          )}
                                          %
                                        </p>
                                      </strong>
                                    </div>
                                  )}

                                  {mainKey === "quantity" && (
                                    <div className="report__table__titletotal">
                                      <strong>
                                        <p>Total</p>
                                      </strong>
                                    </div>
                                  )}
                                  {mainKey === "quantity" && (
                                    <div className="report__table--total">
                                      <p>
                                        {Number(
                                          Object.values(products)
                                            .reduce(
                                              (ttl, data) =>
                                                ttl +
                                                (data[mainTask.value]?.[
                                                  mainKey
                                                ] ?? 0),
                                              0
                                            )
                                            .toFixed(2)
                                        )}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>

                        );
                      })}
                    </div>
                  </>
                ))}
              </>
          ) : (
            <div className="mt-2 w-100 d-flex justify-content-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          )}
        </Container>
      </Card.Body>
    </>
  )
}
